var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"68.6","height":"68.6","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M34.31,68.6A34.3,34.3,0,1,1,68.6,34.29v0A34.34,34.34,0,0,1,34.31,68.6ZM34.31,3A31.3,31.3,0,1,0,65.6,34.32h0A31.33,31.33,0,0,0,34.31,3ZM45.77,53.08A2.52,2.52,0,0,1,44,52.32l-9.67-9.75-9.7,9.75a2.55,2.55,0,0,1-1.87.74A2.48,2.48,0,0,1,21,52.22l-4.44-5a2.52,2.52,0,0,1,.09-3.41l9.44-9.49L16.25,24.4a2.48,2.48,0,0,1,0-3.51h0l4.65-4.65a2.5,2.5,0,0,1,3.53,0l9.88,9.88,9.87-9.87A2.55,2.55,0,0,1,46,15.48a2.44,2.44,0,0,1,1.76.75l4.63,4.63a2.49,2.49,0,0,1,0,3.52l-9.86,9.94L52,43.77a2.52,2.52,0,0,1,.1,3.43l-4.46,5a2.43,2.43,0,0,1-1.77.84ZM34.32,39a1.5,1.5,0,0,1,1.06.44L45.74,49.84l3.8-4.29L39.35,35.37a1.51,1.51,0,0,1,0-2.12L49.88,22.62,46,18.69,35.38,29.32a1.55,1.55,0,0,1-2.12,0L22.67,18.68l-3.94,3.94L29.27,33.25a1.51,1.51,0,0,1,0,2.12L19.09,45.55l3.79,4.29L33.25,39.4A1.54,1.54,0,0,1,34.32,39Z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 68.6 68.6"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-cross-outline.svg
// module id = 296
// module chunks = 0